export type TDateParam = Date | string | number | null | undefined;

export const MONTHLY_PERIOD = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;
export type TMonthlyPeriod = (typeof MONTHLY_PERIOD)[number];

export const QUARTERLY_PERIOD = ['Q1', 'Q2', 'Q3', 'Q4'] as const;
export type TQuarterlyPeriod = (typeof QUARTERLY_PERIOD)[number];

export const HALF_YEARLY_PERIOD = ['H1', 'H2'] as const;
export type THalfYearlyPeriod = (typeof HALF_YEARLY_PERIOD)[number];

export const DATE_BLOCK = ['current', 'base'] as const;
export type TDateBlock = (typeof DATE_BLOCK)[number];

const DAY = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;
export type TDay = (typeof DAY)[number];

export const DAY_NUMBER_MAP: Record<TDay, number> = {
  sun: 0,
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6,
};
